import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const TitleFilter = styled(Typography)`
    font-size: 18px;
    font-weight: bold;
    margin-bottom: ${props => props.primary && '24px'};
`;
